import React from 'react';
import AnalyticsStyleEmptyState from '../common/AnalyticsStyleEmptyState';
import './BuilderEmptyState.css';

interface BuilderEmptyStateProps {
  onNewInterview: () => void;
  variant?: 'full' | 'canvas';
}

const BUILD_EMPTY_ICON = (
  <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
    />
  </svg>
);

const BUILD_EMPTY_HINTS = [
  { icon: '🔍', text: 'Smart build — search a job role in the header' },
  { icon: '📋', text: 'Custom — paste a job description after you start' },
  { icon: '✦', text: 'Add interview rounds and schedule when ready' },
];

const BuilderEmptyState: React.FC<BuilderEmptyStateProps> = ({
  onNewInterview,
  variant = 'canvas',
}) => (
  <div
    className={`builder-empty-state-wrap${
      variant === 'canvas' ? ' builder-empty-state-wrap--canvas' : ' builder-empty-state-wrap--full'
    }`}
  >
    <AnalyticsStyleEmptyState
      title="Build a new interview"
      description="Use Smart build by searching a specific role or paste custom Job description"
      icon={BUILD_EMPTY_ICON}
      primaryLabel="New Custom Interview"
      onPrimary={onNewInterview}
      hints={BUILD_EMPTY_HINTS}
    />
  </div>
);

export default BuilderEmptyState;
